import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	percentOff: {
		id: 'countdownView.promotionUpsell.percentOff',
		defaultMessage: 'Get {percentOff}% off',
		description: 'Tell them that they if they submit their purchase they will get a discount',
	},
	lifetimePriceTitle: {
		id: 'redesign.purchase.purchaseForm.lifetime.priceTitle',
		defaultMessage: 'Lifetime of Calm Premium',
		description: 'Tell them that if they complete their purchase they will have Calm Premium forever',
	},
	yearlyPriceTitle: {
		id: 'redesign.purchase.purchaseForm.yearly.priceTitle',
		defaultMessage: '12 months of Calm Premium',
		description: 'Tell them that if they complete their purchase they will have one year of Calm Premium',
	},
	lifetimeUnlimited: {
		id: 'countdownView.promotionUpsell.bullet.lifetimeUnlimited',
		defaultMessage: 'Get unlimited access, forever',
		description: 'Tell them that if they complete their purchase they will have Calm Premium forever',
	},
	lifetimeImproveSleep: {
		id: 'countdownView.promotionUpsell.bullet.lifetimeImproveSleep',
		defaultMessage: 'Improve sleep and mindfulness – for life',
		description:
			'Tell them that Calm Premium helps them improve sleep and mindfulness, and they will have it forever',
	},
	lifetimeLimitedTime: {
		id: 'countdownView.promotionUpsell.bullet.lifetimeLimitedTime',
		defaultMessage: 'Exclusive, limited time offer',
		description: 'Tell them that we do not plan to always make it possible to buy the lifetime package',
	},
	learnLifeChanging: {
		id: 'newMemberOffer.promotionUpsell.bullet.learnLifeChanging',
		defaultMessage: 'Learn the life-changing skill of meditation',
		description: 'Tell them that Calm helps them learn to meditate',
	},
	fallIntoDeepSleep: {
		id: 'newMemberOffer.promotionUpsell.bullet.fallIntoDeepSleep',
		defaultMessage: 'Fall into a deep sleep with sleep stories',
		description: 'Tell them that Calm helps them fall asleep with Sleep Stories',
	},
	musicTracksForFocus: {
		id: 'newMemberOffer.promotionUpsell.bullet.musicTracksForFocus',
		defaultMessage: 'Music tracks for focus and relaxation',
		description: 'Tell them that Calm comes with exclusive music',
	},
});
